module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/images/FlyerPoster-e8fb0bad90e5a10a79a3cac547712e03.jpg";